import { render, staticRenderFns } from "./esgEdit.vue?vue&type=template&id=09bb4028"
import script from "./esgEdit.vue?vue&type=script&lang=ts"
export * from "./esgEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxDataTableSections: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/Sections.vue').default,IxDataTableQuestions: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/Questions.vue').default})
